import {
  BookOpenIcon,
  BrainIcon,
  CalendarX2Icon,
  ClipboardCheckIcon,
  ClipboardListIcon,
  FileSearchIcon,
  FootprintsIcon,
  MegaphoneIcon,
  TargetIcon,
  TrendingUpIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react'

export type IconName =
  | 'bookOpen'
  | 'brain'
  | 'calendarX'
  | 'clipboardCheck'
  | 'clipboardList'
  | 'fileSearch'
  | 'footprints'
  | 'megaphone'
  | 'target'
  | 'trendingUp'
  | 'users'

export const icons: Record<IconName, LucideIcon> = {
  bookOpen: BookOpenIcon,
  brain: BrainIcon,
  calendarX: CalendarX2Icon,
  clipboardCheck: ClipboardCheckIcon,
  clipboardList: ClipboardListIcon,
  fileSearch: FileSearchIcon,
  footprints: FootprintsIcon,
  megaphone: MegaphoneIcon,
  target: TargetIcon,
  trendingUp: TrendingUpIcon,
  users: UsersIcon,
}
